module.exports = __webpack_public_path__ + "static/turquia-007-856875dd8a3475c27c11c1cba3ca6458.jpg";